import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';
import LoadingComponent from '../../components/common/LoadingComponent';
import { Text } from '../../components/common/Text';
import { FlyInTransition } from '../../components/transitions/transitions';
import arrowBack from '../../images/arrow_back.svg';
import { getAllPodcasts } from '../../services/health-content';
import Modal from '../common/Modal';
import Player from './PodcastPlayer';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
  background: white;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  padding: 0.5rem;
  z-index: 10;
  padding: 0px 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f3f6;
`;

const HeaderText = styled(Text)`
  margin-left: 0.625rem;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #464548;
`;

const BodyContainer = styled.div`
  flex: 1;
  flex-shrink: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20px;
`;

const HeaderNew = styled.div`
  padding: 30px 01px 0px 0px;
  display: flex;
  background: white;
  align-self: stretch;
  align-items: center;
`;

const SectionHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #413958;
  padding-left: 14px;
`;

const HoverContent = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  padding: 16px 13px;
  bottom: 0px;
  left: 0px;
  border-radius: 0px 0px 18px 18px;
  width: 175px;
  color: #ffffff;
`;

const CardTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

const CardDescription = styled.div`
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #e6e6e6;
  margin-top: 2px;
`;

const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
`;

const AngleRight = styled(FaChevronRight)`
  color: #413958;
  width: 8px;
  height: 8px;
`;

class PodcastsHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      allPodcasts: [],
      showPlayerModal: false,
      selectedAlbum: null,
    };
  }

  componentDidMount() {
    this.getAllPodcasts();
    if (
      typeof window.Android !== 'undefined' &&
      window.Android &&
      window.Android.podcastPage
    ) {
      return window.Android.podcastPage();
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'podcastPage',
        })
      );
    }
  }

  getAllPodcasts() {
    getAllPodcasts(this.props.authToken)
      .then((res) => {
        console.log(res, 'podcasts_data');
        this.setState({ allPodcasts: res.cards });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  onAlbumClick = (album) => {
    if (album.showAudioPlayer) {
      this.setState({ selectedAlbum: album, showPlayerModal: true });
    } else {
      //it is a album container
      console.log(album, 'here it is');
      this.props.history.push('/health-content/sub-podcasts', {
        albumId: album.albumId,
      });
    }
  };

  hideModal = () => {
    console.log('clicked');
    this.setState({ showPlayerModal: false });
  };

  render() {
    const { allPodcasts, showPlayerModal, selectedAlbum, loading } = this.state;
    if (loading) {
      return <LoadingComponent />;
    }
    const renderPodcastCards = (cards) => {
      return cards.map((card) => {
        const albums = card.albums;
        return (
          <div style={{ marginTop: '25px' }}>
            <div className="flex justify-between px-10px">
              <SectionHeader>{card.title}</SectionHeader>
              <div
                className="flex items-center pr-12px cursor-pointer"
                onClick={() =>
                  this.props.history.push(
                    `/health-content/podcasts-home/${card.type}`,
                    {
                      card,
                    }
                  )
                }
              >
                <p className="text-body-l font-semibold text-purpleText">
                  See all
                </p>
                <div className="p-5 bg-primary-shades1 rounded-full ml-8px">
                  <AngleRight />
                </div>
              </div>
            </div>
            {albums && albums.length > 0 && (
              <div className="flex overflow-x-auto justify-start mt-16px px-24px">
                {albums.map((album) => {
                  return (
                    <button
                      style={{ position: 'relative' }}
                      onClick={() => this.onAlbumClick(album)}
                      className="text-left"
                    >
                      <img
                        src={album.imageUrl}
                        style={{
                          width: '175px',
                          height: '175px',
                          marginRight: '200px',
                          borderRadius: '18px',
                        }}
                      />
                      <HoverContent>
                        <CardTitle>{album.albumTitle}</CardTitle>
                        <CardDescription>{album.coachName}</CardDescription>
                      </HoverContent>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      });
    };

    return (
      <OuterContainer>
        <HeaderContainer>
          <HeaderNew>
            <img
              src={arrowBack}
              className="cursor-pointer"
              onClick={this.props.history.goBack}
              style={{ width: '36px' }}
            />
            <HeaderText>Meditation</HeaderText>
          </HeaderNew>
        </HeaderContainer>
        <BodyContainer>
          <div>{renderPodcastCards(allPodcasts)}</div>
          {/* <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(personalGrowthAlbums)}
          </div>
          <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(workAlbums)}
          </div> */}
        </BodyContainer>
        {showPlayerModal && (
          <Modal>
            <ModalContainer onClick={this.hideModal}>
              <FlyInTransition
                in={showPlayerModal}
                mountOnEnter
                unmountOnExit
                appear
              >
                <Player
                  album={selectedAlbum}
                  authToken={this.props.authToken}
                  hideModal={this.hideModal}
                />
              </FlyInTransition>
            </ModalContainer>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(PodcastsHome);
